import { render, staticRenderFns } from "./m-chart-leaderboard.vue?vue&type=template&id=0b87cfe7&scoped=true&"
import script from "./m-chart-leaderboard.vue?vue&type=script&lang=js&"
export * from "./m-chart-leaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87cfe7",
  null
  
)

export default component.exports